import { Record } from 'immutable';
import _ from 'lodash';

const properties = {
  type: String('Point'),
  coordinates: [Number()],
};

export default class LocationLatLng extends Record(properties, 'LocationLatLng') {
  public readonly type!: string;

  public readonly coordinates!: number[];

  constructor(values: any = {}) {
    super(_.pick(values, Object.keys(properties)));
  }
}
